import {
  createBrowserRouter,
  Navigate,
  RouterProvider,
} from "react-router-dom";
import SubscribePage from "../pages/SubscribePage";
import LoginPage from "../pages/LoginPage";
import HomePage from "../pages/HomePage";
import SelectCaptainAndViceCaptain from "../pages/SelectCaptainAndViceCaptain";
import LiveMatches from "../pages/LiveMatches";
import MatchDetails from "../pages/MatchDetails";
import FantasyGame from "../pages/FantasyGame";
import CreateFantasyTeam from "../pages/CreateFantasyTeam";
import MyMatches from "../pages/MyMatches";
import CreatePrediction from "../pages/CreatePrediction";
import PredictionGame from "../pages/PredictionGame";
import Leaderboard from "../pages/Leaderboard";
import Profile from "../pages/Profile";
import Auth from "../component/Auth";
import EditProfile from "../pages/EditProfile";
import ErrorBoundary from "../pages/ErrorBoundary";
import TNCPage from "../pages/TNCPage";
import SubscriptionInfo from "../pages/SubscriptionInfo";
import TermsPage from "../pages/TermsPage";
import WinningHistory from "../pages/WinningHistory";
import FaqPage from "../pages/FaqPage";

const Routing = () => {
  const router = createBrowserRouter([
    { path: "/", element: <SubscribePage />, errorElement: <ErrorBoundary /> },
    { path: "/login", element: <LoginPage />, errorElement: <ErrorBoundary /> },
    { path: "/tnc", element: <TNCPage />, errorElement: <TNCPage /> },
    {
      path: "/home",
      element: (
        <Auth>
          <HomePage />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/create-fantasy-team",
      element: (
        <Auth>
          <CreateFantasyTeam />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/select-captains",
      element: (
        <Auth>
          <SelectCaptainAndViceCaptain />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/fantasy-game",
      element: (
        <Auth>
          <FantasyGame />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    //1).showinguserrankisleft,2).showinghowtheplayerhasgotthepointisleft,3).matchcommentryisleft...{path:"/fantasy-game",element:<Auth><FantasyGame/></Auth>,errorElement:<ErrorBoundary/>},
    {
      path: "/live",
      element: (
        <Auth>
          <LiveMatches />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/match-details",
      element: (
        <Auth>
          <MatchDetails />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/my-matches",
      element: (
        <Auth>
          <MyMatches />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },

    // this is added
    {
      path: "/create-prediction",
      element:
        <Auth>
          <CreatePrediction />
        </Auth>,
      errorElement: <ErrorBoundary />
    },
    // this is added
    {
      path: "/prediction-game",
      element:
        <Auth>
          <PredictionGame />
        </Auth>,
      errorElement: <ErrorBoundary />
    },
    {
      path: "/leaderboard",
      element: (
        <Auth>
          <Leaderboard />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/profile",
      element: (
        <Auth>
          <Profile />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/subscription-info",
      element: (
        <Auth>
          <SubscriptionInfo />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/win-history",
      element: (
        <Auth>
          <WinningHistory />,
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/terms",
      element: (
        <Auth>
          <TermsPage />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/faq",
      element: (
        <Auth>
          <FaqPage />
        </Auth>
      ),
      errorElement: <ErrorBoundary />,
    },
    {
      path: "/edit-profile",
      element: (
        <Auth>
          <EditProfile />
        </Auth>
      ),

      errorElement: <ErrorBoundary />,
    },
    { path: "*", element: <Navigate to="/" /> },
  ]);
  return <RouterProvider router={router} />;
};

export default Routing;
